import React from 'react';
import completeIcon from '../../assets/complete.png';
import { message, Modal, Tooltip } from 'antd';
import { CheckCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { useDocument } from '../../context/documentInfoContex';
import { workwiseServices } from '../../api';
import './completeDoc.css';

const { confirm } = Modal;

const CompleteDocument = () => {
    const { documentInfo, setIsReadOnly } = useDocument();

    const handleClick = async () => {
        try {
            await workwiseServices.completeDocument(documentInfo.referenceId);
            message.success('Document completed successfully.');
            setIsReadOnly(true);
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            className: 'complete-doc-confirm',
            icon: null,
            title: (
                <>
                    <span className="complete-doc-confirm__badge">
                        <ExclamationCircleOutlined />
                    </span>
                    <span className="complete-doc-confirm__title">Complete this document?</span>
                </>
            ),
            content: (
                <>
                    <p className="complete-doc-confirm__text">
                        Once completed, this document is locked. You won't be able to edit or reopen it.
                    </p>
                </>
            ),
            okText: (
                <>
                    <CheckCircleFilled />
                    Complete document
                </>
            ),
            okButtonProps: { type: 'primary' },
            closable: true,
            cancelText: 'Cancel',
            onOk() {
                handleClick();
            },
            onCancel() {
            },
            zIndex: 9999,
            maskClosable: true,
        });
    };

    return (
        <Tooltip title="Complete document">
            <button type="button" className="complete-doc-trigger" onClick={showConfirmationModal} aria-label="Complete document">
                <img src={completeIcon} alt="" />
            </button>
        </Tooltip>
    );
};

export default CompleteDocument;
